import { useContext } from 'react'

import { HeroTitleWrapper, HeroTitle } from '../Hero'

import { ReliabilityCalculatorContext } from './Context'

import {
  ReliabilityOption,
  ReliabilityCell,
  ReliabilityGrid,
} from '~partials/reliability-calculator/UI'

const Step8 = () => {
  const {
    state: { step8 },
    dispatch,
  } = useContext(ReliabilityCalculatorContext)

  return (
    <ReliabilityCell>
      <HeroTitleWrapper className="u-contrast" bottomSpace>
        <HeroTitle>
          Does this service have dedicated monitoring and alerting ?
        </HeroTitle>
      </HeroTitleWrapper>
      )
      <ReliabilityGrid size="3">
        <ReliabilityOption
          title="Yes"
          active={step8 === 'yes-monitoring-alerting'}
          onClick={() => {
            dispatch({
              type: 'choice',
              payload: {
                step8: 'yes-monitoring-alerting',
              },
            })
          }}
        >
          <p>
            This service is actively monitored and has established alerting
            thresholds.
          </p>
        </ReliabilityOption>
        <ReliabilityOption
          title="Yes"
          active={step8 === 'yes-monitoring'}
          onClick={() => {
            dispatch({
              type: 'choice',
              payload: {
                step8: 'yes-monitoring',
              },
            })
          }}
        >
          <p>This service is actively monitored.</p>
        </ReliabilityOption>
        <ReliabilityOption
          title="No"
          active={step8 === 'no'}
          onClick={() => {
            dispatch({
              type: 'choice',
              payload: {
                step8: 'no',
              },
            })
          }}
        >
          <p>This service has no active monitoring.</p>
        </ReliabilityOption>
      </ReliabilityGrid>
    </ReliabilityCell>
  )
}

export default Step8
